// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { OperandFunction_abstract } from './../../abstract/SagaBase/Objects/OperandFunction_abstract';
export class OperandFunction extends OperandFunction_abstract {}
